<template>
	<v-btn
			class="rounded"
			:class="{
				'v-btn--active': editor.isFocused && editor.isActive('strike')
			}"
			:color="editor.isFocused && editor.isActive('strike') ? 'primary' : 'transparent'"
			depressed
			fab
			small
			@click="editor.chain().focus().toggleStrike().run()"
			@mousedown.stop.prevent
	>
		<v-icon>
			mdi-format-strikethrough
		</v-icon>
	</v-btn>
</template>

<script>
export default {
	name: 'Strike',
	props: {
		editor: Object
	}
}
</script>